import { Flex, FlexProps } from '@tonic-one/react';
import { PocRightTransferBox } from './pocRightTransferBox';
import { PocLeftTransferBox } from './pocLeftTransferBox';
import { ToRight } from './toRight';
import { usePocTransferTree } from './hooks';
import React, { useImperativeHandle } from 'react';

export const PocTransFer = React.forwardRef<
  { data: object[] },
  { orgId: string; toRightStyle?: Partial<FlexProps> }
>(({ orgId, toRightStyle = {} }, ref) => {
  const {
    sourceData,
    targetData,
    handleToRightClick,
    toggleNodeChecked,
    toggleNodeExpanded,
    onSearch,
    removeTargetDataByKey,
  } = usePocTransferTree(orgId);

  useImperativeHandle(ref, () => {
    return {
      data: targetData.map((d) => d.target),
    };
  }, [targetData]);

  return (
    <Flex>
      <PocLeftTransferBox
        data={sourceData}
        toggleNodeChecked={toggleNodeChecked}
        toggleNodeExpanded={toggleNodeExpanded}
        onSearch={onSearch}
      />

      <ToRight
        highlight={true}
        onClick={handleToRightClick}
        style={toRightStyle}
      />

      <PocRightTransferBox onDelete={removeTargetDataByKey} data={targetData} />
    </Flex>
  );
});
